import { useMutation } from "react-query";
import {
  reportUpdateReportCategory,
  reportUpdateReport,
  reportDeleteReport,
  reportCreateReportList,
  reportUpdateReportList,
  reportDeleteHotelReports,
} from "../api/report";

export const useReportUpdateReportCategory = (options = {}) =>
  useMutation(reportUpdateReportCategory, options);

export const useReportUpdateReport = (options = {}) =>
  useMutation(reportUpdateReport, options);

export const useReportDeleteReport = (options = {}) =>
  useMutation(reportDeleteReport, options);

export const useReportDeleteHotelReport = (options = {}) =>
  useMutation(reportDeleteHotelReports, options);

export const useReportUpdateReportList = (options = {}) =>
  useMutation(reportUpdateReportList, options);

export const useReportCreateReportList = (options = {}) =>
  useMutation(reportCreateReportList, options);

export default {
  useReportUpdateReportCategory,
  useReportUpdateReport,
  useReportDeleteReport,
  useReportUpdateReportList,
  useReportCreateReportList,
  useReportDeleteHotelReport,
};
